import { render, staticRenderFns } from "./TemplateEditorPlaceholderDropdown.vue?vue&type=template&id=94b3902a&scoped=true"
import script from "./TemplateEditorPlaceholderDropdown.vue?vue&type=script&lang=ts"
export * from "./TemplateEditorPlaceholderDropdown.vue?vue&type=script&lang=ts"
import style0 from "./TemplateEditorPlaceholderDropdown.vue?vue&type=style&index=0&id=94b3902a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94b3902a",
  null
  
)

export default component.exports